export default __webpack_public_path__ + "static/9_35-1fbd8e5ac0ce9a2db7eec63822a4503e.png";